import { render, staticRenderFns } from "./AzmazingProducts.component.vue?vue&type=template&id=01de88cc&scoped=true"
import script from "./AzmazingProducts.component.vue?vue&type=script&lang=js"
export * from "./AzmazingProducts.component.vue?vue&type=script&lang=js"
import style0 from "./AzmazingProducts.component.vue?vue&type=style&index=0&id=01de88cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de88cc",
  null
  
)

export default component.exports